import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const NewSurveySubmitted = () => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "90vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // bgcolor: "#f5f5f5",
        // px: { xs: 1, sm: 2, md: 4 },
        // py: { xs: 2, sm: 4, md: 6 },
      }}
    >
      <Grid
        container
        justifyContent="center"
        // alignItems="center"
        sx={{
          background: "#ffc20e",
          p: { xs: 0.5, sm: 0.5, md: 0.8 },
          minHeight: { xs: "340px", sm: "420px", md: "520px" },
          // maxWidth: { xs: "100%", sm: "500px", md: "600px" },
          borderRadius: { xs: 2, sm: 2, md: 1 },
          // boxShadow: { xs: 1, sm: 2, md: 4 },
        }}
      >
        <Box
          sx={{
            background: "#fff",
            width: "100%",
            // pb: { xs: 2, sm: 3, md: 4 },
            borderRadius: { xs: 2, sm: 2, md: 1 },
            // boxShadow: { xs: 0, sm: 1, md: 0.6 },
          }}
        >
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                pt: { xs: 1, sm: 2 },
                pr: { xs: 1, sm: 2 },
              }}
            >
              <img
                src={
                  "data:image/png;base64,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"
                }
                alt="brigade"
                style={{
                  maxWidth: "100%",
                  width: "auto",
                  height: "auto",
                  maxHeight: "22vh",
                  // objectFit: "contain",
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "center", p: 2, mt: 3 }}>
            {/* <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                px: { xs: 2, sm: 4, md: 6 },
                py: { xs: 2, sm: 3, md: 4 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    width: { xs: 56, sm: 72, md: 80 },
                    height: { xs: 56, sm: 72, md: 80 },
                    mb: { xs: 2, sm: 3, md: 4 },
                  }}
                >
                  <img
                    src={TickImg}
                    alt="Success"
                    style={{ width: "100%", height: "auto" }}
                  />
                </Box>

                <Typography
                  variant="h1"
                  sx={{
                    mt: { xs: 2, sm: 3, md: 4 },
                    fontWeight: 700,
                    color: "#222",
                    fontSize: {
                      xs: "1.4rem",
                      sm: "1.7rem",
                      md: "2.2rem",
                      lg: "2.5rem",
                    },
                    textAlign: "center",
                  }}
                >
                  Thank You
                </Typography>
              </Box>
            </Box> */}
            <Typography variant="h1">Survey already filled</Typography>
            <Typography sx={{}}>
              Thank you for participating! Your survey response has already been
              submitted.
            </Typography>
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};

export default NewSurveySubmitted;
